// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4f8a34d7","147":"9fe9b391","156":"097d0179","438":"387cc76a","706":"678e0a62","726":"a75e817e"}[chunkId] + ".chunk.js";
};